<template>
  <div class="w-full">
    <b-modal
      v-model="modalVerErro"
      :title="titulo"
      centered
      size="lg"
      hide-footer
      @hidden="closeModal"
    >
      <div class="w-full vs-con-loading__container" id="erroConsulta">
        <VuePerfectScrollbar class="scroll-erros m-0 p-0" :settings="confScroll">
          <div v-for="(data, index) in erro" :key="index" style="padding: 12px; border-bottom: 1px solid #eee; margin-bottom: 12px;">
            <vs-row>
              <vs-col vs-w="12" style="margin-bottom: 6px;">
                <!-- Solicitado: Erro todo em vermelho -->
                <span style="color: #ea5455; font-weight: bold; font-size: 14px;">
                  Erro: {{ data.Codigo }}
                </span>
              </vs-col>
              <vs-col vs-w="12">
                <span style="font-weight: 600; font-size: 12px; color: #333;">Descrição:</span>
                <span style="font-size: 12px; margin-left: 5px; color: #555;">{{ data.Descricao }}</span>
                <span v-if="data.Complemento" style="font-size: 12px; margin-left: 5px; color: #777;">
                  - {{ data.Complemento }}
                </span>
              </vs-col>
              <vs-col vs-w="12" v-if="data.ComoCorrigir" style="margin-top: 10px;">
                <div style="background-color: #f0fdf4; border-left: 4px solid #22c55e; padding: 10px 14px; border-radius: 4px;">
                  <span style="font-weight: bold; color: #15803d; font-size: 13px; display: block; margin-bottom: 4px;">
                    🛠️ Como corrigir no sistema:
                  </span>
                  <span style="font-size: 12px; color: #166534; line-height: 1.5; display: block;">
                    {{ data.ComoCorrigir }}
                  </span>
                </div>
              </vs-col>
            </vs-row>
          </div>
          <div style="margin-top: 20px; text-align: right; padding: 10px;">
             <vs-button color="danger" type="flat" @click="modalVerErro = false">Fechar</vs-button>
          </div>
        </VuePerfectScrollbar>
      </div>
    </b-modal>
  </div>
</template>
<script>
import components from "@/components/default/exports.js"
export default {
  props: {
    titulo: { default: "Ver Erros" },
    nota: {},
    json: null,
  },
  data () {
    return {
      modalVerErro: false,
      erro: [],
      confScroll: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
    }
  },
  methods: {
    obterInstrucaoCorrecao (codigo, descricao) {
      var cod = (codigo || "").toString().toUpperCase().trim();
      var desc = (descricao || "").toString().toLowerCase();

      if (cod === "E0178" || desc.indexOf("regime especial de tributação não permitido") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e altere o campo 'Regime Especial de Tributação' para '0 - Nenhum' (ou para o regime especial homologado pela prefeitura para a sua atividade). Empresas de controle de pragas ou optantes do Simples Nacional não utilizam o código 6 (Sociedade de Profissionais).";
      }

      if (cod === "E0312" || desc.indexOf("não está administrado pelo município") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e preencha o 'Código Tributação Municipal' (para Manaus, utilize 100). Em prefeituras que possuem tabela própria de serviços, o código nacional (071301) deve obrigatoriamente estar vinculado ao código municipal.";
      }

      if (cod === "E0314" || desc.indexOf("código de tributação municipal não deve ser informado") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e deixe o campo 'Código Tributação Municipal' em branco. Municípios como Itajaí não utilizam tabela própria de códigos municipais na DPS nacional.";
      }

      if (cod === "E0166" || desc.indexOf("regime de apuração dos tributos do sn") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e selecione o 'Regime de Apuração no Simples Nacional (regApTribSN)' da empresa (ex: 1 - Tributos federais e municipal pelo Simples Nacional).";
      }

      if (cod === "E0160" || desc.indexOf("situação perante o simples nacional") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e ajuste o campo 'Optante pelo Simples Nacional' de acordo com o enquadramento cadastrado na Receita Federal (1 - Não Optante, 2 - MEI, 3 - ME ou EPP).";
      }

      if (cod === "E0010" || desc.indexOf("série informada na dps não pertence à faixa") !== -1) {
        return "Acesse o menu Configurações > Empresa, localize o card 'Configurações Fiscais NFS-e' e configure a 'Série da DPS' com o valor credenciado junto à prefeitura ou Sefin Nacional (padrão '00900').";
      }

      if (cod === "E0120" || desc.indexOf("im do prestador não deve ser informado") !== -1) {
        return "A prefeitura deste município emissor dispensa o envio da Inscrição Municipal na DPS nacional. Acesse o menu Configurações > Empresa e revise a Inscrição Municipal (CCM) do prestador.";
      }

      if (cod === "E0014" || desc.indexOf("já existe em uma nfs-e gerada") !== -1) {
        return "Esta DPS já foi transmitida anteriormente para a Sefin Nacional. Acesse a tela de 'Conferência Diária' ou a grade de notas e clique em 'Consultar Protocolo' para sincronizar a nota autorizada em vez de reenviar.";
      }

      return null;
    },
    async openModal () {
      this.modalVerErro = true
      
      let dataJson = this.json;
      if (typeof dataJson === 'string') {
          try {
              dataJson = JSON.parse(dataJson);
          } catch(e) {
              console.error("Erro parse JSON verErros", e);
          }
      }

      this.erro = [];

      if (dataJson) {
        // PRIORIDADE 1: Erros do Fiscal Core (Novo Padrão)
        // O backend retorna 'erros' no serverStatus. Isso é o mais detalhado e correto.
        if (dataJson.erros && Array.isArray(dataJson.erros) && dataJson.erros.length > 0) {
           this.erro = dataJson.erros.map(e => ({
               Codigo: e.Codigo,
               Descricao: e.Descricao,
               Complemento: e.Complemento,
               ComoCorrigir: this.obterInstrucaoCorrecao(e.Codigo, e.Descricao)
           }));
           return;
        }

        // PRIORIDADE 2: ListaMensagemRetorno (Legado / Adapter Backend)
        // Se não tiver 'erros', tentamos pegar do formato antigo ou adaptado
        if (dataJson.ListaMensagemRetorno) {
          let lista = dataJson.ListaMensagemRetorno.MensagemRetorno;
          if (!Array.isArray(lista)) lista = [lista];
          
          this.erro = lista.map(e => {
            // Tenta extrair código da mensagem se não existir propriedade Codigo (ex: "RNG6110 - Descricao")
            let cod = e.Codigo;
            let msg = e.Mensagem;

            return {
                Codigo: cod || 'Erro',
                Descricao: msg,
                Complemento: e.Correcao, // Mapeia Correção antiga para "complemento" se existir
                ComoCorrigir: this.obterInstrucaoCorrecao(cod, msg)
            }
          });
          return;
        }
        
        // ULTIMO CASO: Objeto direto sem estrutura conhecida
        var codDireto = dataJson.codigo || dataJson.status || 'Erro';
        var descDireto = dataJson.mensagem || dataJson.message || JSON.stringify(dataJson);
        this.erro.push({
            Codigo: codDireto,
            Descricao: descDireto,
            Complemento: '',
            ComoCorrigir: this.obterInstrucaoCorrecao(codDireto, descDireto)
        });

      } else {
        // Se não veio JSON no props, tenta buscar via API (Legado total)
        await this.getErrosConsulta()
      }
    },
    async getErrosConsulta () {
      await this.$vs.loading({
        container: "#erroConsulta",
        scale: 0.6,
      })
      try {
        let res = await this.$http.get(`getErroConsulta/${this.nota.rps}`)
        // Adapter para o formato do novo array 'erro'
        if (Array.isArray(res)) {
            this.erro = res.map(e => ({
                Codigo: e.Codigo,
                Descricao: e.Mensagem,
                Complemento: e.Correcao,
                ComoCorrigir: this.obterInstrucaoCorrecao(e.Codigo, e.Mensagem)
            }))
        } else {
             this.erro = [{
                Codigo: res.Codigo || 'Erro',
                Descricao: res.Mensagem || JSON.stringify(res),
                Complemento: res.Correcao,
                ComoCorrigir: this.obterInstrucaoCorrecao(res.Codigo, res.Mensagem)
             }]
        }

      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        await this.$vs.loading.close("#erroConsulta > .con-vs-loading")
      }
    },
    async closeModal () {
      this.modalVerErro = false
    },
  },
  async mounted () {
    await this.openModal()
  },
  components: {
    ...components,
  },
};
</script>
<style scoped>
.scroll-erros {
  height: 52vh !important;
}
</style>
